const o = /* @__PURE__ */ Symbol("dialogInjectionKey"), e = "dialog-fade";
export {
  e as DEFAULT_DIALOG_TRANSITION,
  o as dialogInjectionKey
};
